import { useEffect, useRef, useState } from 'react';
import './Histogram.css';
import { scoreToCssClass } from './State.tsx';

function Histogram({ bins, frequencies, lastScore }) {
    const [firstRender, setFirstRender] = useState<boolean>(true);

    const displayedFrequencies = initializeFrequencies();
    function initializeFrequencies() {
        const displayedFrequencies = Object.assign({}, frequencies);
        if (firstRender && lastScore) {
            displayedFrequencies[lastScore] -= 1;
        }
        return displayedFrequencies;
    }
    const values = Object.values(frequencies) as number[];
    const max = Math.max(...values);

    useEffect(() => {
        setTimeout(() => {
            setFirstRender(false);
        }, 500);
    });

    return (
        <div className='histogram-outer-container'>
            <div className='histogram-label-container'>
                {bins.map((bin) => {
                    const count = displayedFrequencies[bin] || 0;
                    return (
                        <div className='histogram-row' key={bin}>
                            <div className='histogram-label' data-testid={`histogram-count-${bin}`}>
                                {bin}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className='histogram-bars-container'>
                {bins.map((bin) => {
                    const count = displayedFrequencies[bin] || 0;
                    return (
                        <div className='histogram-row' key={bin}>
                            <div className='histogram-bar-container'>
                                <div
                                    className={`${scoreToCssClass(bin)} histogram-bar ${
                                        lastScore !== bin ? 'histogram-bar-inactive' : ''
                                    }`}
                                    style={{
                                        width: `${((count / max) * 100).toFixed(0)}%`,
                                    }}>
                                    <div
                                        className={`histogram-count-label ${
                                            count / max < 0.1 ? 'histogram-count-label-small' : ''
                                        }`}>
                                        {count}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export { Histogram };
